import aa from "search-insights";
import AlgoliaConfig from "controller/algolia/algoliaConfig";
import AlgoliaSetCookie from "controller/algolia/algoliaSetCookie";

let instance = null;

export default class AlgoliaSendEvent
{
    constructor()
    {
        if (! instance) {
            instance = this;
            this.algoliaConfig = new AlgoliaConfig();
        }

        return instance;
    }

    productAddedToCart(eventData)
    {
        if (this.algoliaConfig.isTrackingEnabled()) {
            const args = {
                userToken: this.algoliaConfig.getUserSessionToken(),
                authenticatedUserToken: this.algoliaConfig.getUserAccountToken(),
                // WARNING: Changing this event name can effect existing tracking.
                eventName: 'Added To Cart',
                index: this.algoliaConfig.getIndex(),
                queryID: eventData.queryID ? eventData.queryID : null,
                objectIDs: [eventData.productId],
                objectData: [{
                    price: eventData.price ? eventData.price : null,
                    quantity: parseInt(eventData.quantity)
                }],
            };

            if (eventData.price) {
                args.value = eventData.price * parseInt(eventData.quantity);
                args.currency = 'GBP';
            }

            aa('addedToCartObjectIDsAfterSearch', args);
        }
    }

    productClick(hit, clickEventName)
    {
        // WARNING: Events shouldn't be renamed unless absolutely necessary, as this effects existing tracking.
        // More event names can be added if needed.
        const validEventNames = [
            'Homepage Product Click', // Used on the Homepage.
            'Recommend Product Click', // Used for Algolia Recommend.
            'Add To Basket Product Click', // Used for Algolia Recommend on the add to basket upsell.
            'Product Click' // Used for Algolia Search.
        ];

        if (this.algoliaConfig.isTrackingEnabled() && validEventNames.includes(clickEventName)) {
            const method = hit.__queryID ? 'clickedObjectIDsAfterSearch' : 'clickedObjectIDs';

            let params = {
                userToken: this.algoliaConfig.getUserSessionToken(),
                authenticatedUserToken: this.algoliaConfig.getUserAccountToken(),
                index: this.algoliaConfig.getIndex(),
                eventName: clickEventName,
                objectIDs: [hit.objectID]
            };

            if (hit.__queryID) {
                params.queryID = hit.__queryID;
                params.positions = [hit.__position];
                (new AlgoliaSetCookie()).setCookie(hit.__queryID);
            }

            aa(method, params).then(() => {
                if (clickEventName !== 'Add To Basket Product Click') {
                    window.location.href = hit.url;
                }
            });
        } else if (!validEventNames.includes(clickEventName)) {
            alert("Invalid event name '" + clickEventName + "'");
        } else {
            if (clickEventName !== 'Add To Basket Product Click') {
                window.location.href = hit.url;
            }
        }
    }

    purchaseComplete(items, total)
    {
        if (this.algoliaConfig.isTrackingEnabled()) {
            const objectIDs = [];
            const objectData = [];
            items.forEach(function (item) {
                objectIDs.push(item['objectID']);
                objectData.push(
                    {
                        queryID: item['queryID'] ? item['queryID'] : null,
                        price: item['price'],
                        discount: item['discount'],
                        quantity: item['quantity']
                    }
                )
            })

            aa('purchasedObjectIDsAfterSearch', {
                userToken: this.algoliaConfig.getUserSessionToken(),
                authenticatedUserToken: this.algoliaConfig.getUserAccountToken(),
                // WARNING: Changing this event name can effect existing tracking.
                eventName: 'Purchase Complete',
                index: this.algoliaConfig.getIndex(),
                objectIDs: objectIDs,
                objectData: objectData,
                value: total,
                currency: 'GBP'
            });
        }
    }
}